import { Trans } from '@lingui/react/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { cn } from 'noddi-ui-common';
import { NoddiButton, NoddiButtonProps } from 'noddi-ui-web';
import { useAuthContext } from 'noddi-web';
import { useState } from 'react';
import { getCanDownloadBookingReceipt } from '../../utils/booking';
import { ApiErrorMessageWithTrans } from '../Error/ApiErrorMessageWithTrans';
import { CustomerLoginModal } from '../Login/CustomerLoginModal';

interface DownloadReceiptButtonProps {
  booking: BookingRecordDetailsCustomer;
  variant?: NoddiButtonProps['variant'];
  className?: string;
}

export const DownloadBookingReceiptButton = ({
  booking,
  variant = 'outline',
  className
}: DownloadReceiptButtonProps) => {
  const { isLoggedIn } = useAuthContext();
  const [openLoginModal, setOpenLoginModal] = useState(false);

  const {
    mutateAsync: downloadReceipt,
    isPending: isDownloadingReceiptLoading,
    error: downloadReceiptError
  } = noddiAsync.useDownload({
    type: URLKeys.downloadBookingReceipt
  });

  if (!getCanDownloadBookingReceipt(booking)) {
    return null;
  }

  return (
    <div className='flex flex-col'>
      {downloadReceiptError && (
        <div className='mb-3'>
          <ApiErrorMessageWithTrans error={downloadReceiptError} />
        </div>
      )}

      <NoddiButton
        loading={isDownloadingReceiptLoading}
        startIcon='Download'
        variant={variant}
        className={cn('w-full md:w-fit', className)}
        // oxlint-disable-next-line typescript/no-misused-promises -- async onClick runs downloadReceipt(); React discards the returned promise, so a rejection is unhandled unless the body catches
        onClick={async () => {
          isLoggedIn ? await downloadReceipt({ bookingId: booking.id }) : setOpenLoginModal(true);
        }}
      >
        <Trans>Download receipt</Trans>
      </NoddiButton>
      <CustomerLoginModal
        open={openLoginModal}
        onClose={() => setOpenLoginModal(false)}
        // oxlint-disable-next-line typescript/no-misused-promises -- async onLoginSuccess runs downloadReceipt(); React discards the returned promise, so a rejection is unhandled unless the body catches
        onLoginSuccess={async () => {
          await downloadReceipt({ bookingId: booking.id });
        }}
      />
    </div>
  );
};
